import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { shouldDisableDate } from '../../helpers';
import './CustomDatePicker.sass';

const CustomDatePicker = (props) => {

    const {
        label,
        value,
        onChange,
        minDate,
        maxDate,
        disablePastDates = false,
        disabled = false
    } = props;
 
    const [date, setDate] = useState(value);

    const handleChange = (val) => {
        // console.log("date", val?.$d)
        
        /** Number.isNaN() only returns true for actual NaN values, 
        while global isNaN() coerces non-numbers to numbers first, 
        leading to unexpected results */
        if (val?.$d && !Number.isNaN(val.$d.getTime())) {
            setDate(val.$d);
            onChange(val.$d);
        }
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={label}
                value={date}
                onChange={handleChange}
                renderInput={(params) => <TextField {...params} />}
                minDate={minDate}
                maxDate={maxDate}
                shouldDisableDate={disablePastDates && shouldDisableDate}
                disabled={disabled}
            />
        </LocalizationProvider>
    )
}

CustomDatePicker.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.instanceOf(Date),
    onChange: PropTypes.func.isRequired,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    disablePastDates: PropTypes.bool,
    disabled: PropTypes.bool
};

export default CustomDatePicker